module.exports = __webpack_public_path__ + "static/img/MX@2x.be780491.jpg";